import { useEffect, useState } from 'react';
import { Alert, Button, Form, Table } from 'react-bootstrap';
import { ModalBorrarVehiculo } from './ModalBorrarVehiculo';
import { ModalEditarVehiculo } from './ModalEditarVehiculo';
import edit_icon from '../../assets/images/edit-icon-new.svg';
import delete_icon from '../../assets/images/delete-icon-new.svg';
import reactivate_icon from '../../assets/images/reactivate-icon-new.svg';
import { useTranslation } from 'react-i18next';
import { Pagination } from '../ui/Pagination';
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai';
import axiosApi from '../../axios/axios-api';
import { toast } from 'react-toastify';
import { LogoPetroprix } from '../ui/LogoPetroprix';
import { ModalReactivarVehiculo } from './ModalReactivarVehiculo';
import { ModalNuevoVehiculo } from './ModalNuevoVehiculo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { ModalInfoBloqueado } from './ModalInfoBloqueado';
import { useDispatch } from 'react-redux';
import { ValidateToken } from '../../helpers/validateToken';
import { startLogout } from '../../store/auth';

export const TablaVehiculosFlota = ({
  vehiculos,
  token,
  estadoFlota,
  onChange,
  orderData,
  onSelectVehicle,
}) => {
  const [modalEditar, setModalEditar] = useState({
    show: false,
    id_cuenta_facturacion: null,
    factura: null,
    credito_definido: null,
    credito_usado: null,
    matricula: null,
    descripcion: null,
    max_operacion: null,
    max_imp_red: null,
    max_op_30: null,
    id_vehiculo_flota: null,
    tipo_vehiculo: null,
  });
  const [modalBorrar, setModalBorrar] = useState({
    show: false,
    vehiculo: null,
  });
  const [modalReactivar, setModalReactivar] = useState({
    show: false,
    vehiculo: null,
  });

  const [modalNuevo, setModalNuevo] = useState({
    show: false,
    vehiculo: null,
  });

  const [modalInfoBloqueado, setModalInfoBloqueado] = useState({
    show: false,
    vehiculo: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [allVehicles, setAllVehicles] = useState(false);

  const nPages = Math.ceil(vehiculos.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = vehiculos.slice(indexOfFirstRecord, indexOfLastRecord);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const switchEstado = (estado) => {
    switch (estado) {
      case '1':
      case 1:
        return (
          <Alert variant='success'>{t('flotas.table.estado-activo')}</Alert>
        );
      case '0':
      case 0:
        return (
          <Alert variant='default'>{t('flotas.table.estado-inactivo')}</Alert>
        );
      default:
        return (
          <Alert variant='warning'>{t('flotas.table.estado-bloqueado')}</Alert>
        );
    }
  };

  const normalizarMatricula = (matricula) => {
    matricula = matricula.split('-');
    matricula = matricula[matricula.length - 1];

    return matricula;
  };

  const updateRow = (id, tipo, info = null) => {
    onChange();
  };

  const fetchTarjetaData = async (id) => {
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(`flotas/vehiculos/${id}`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        });
        if (response?.data?.code === 200) {
          let data = response.data.data;
          setModalEditar({
            show: true,
            id_vehiculo_flota: data.id_vehiculo_flota,
            id_cuenta_facturacion: data.id_cuenta_facturacion,
            credito_definido: data.credito_definido,
            credito_usado: data.credito_usado,
            matricula: data.matricula,
            factura: data.factura,
            descripcion: data.descripcion,
            max_operacion: data.max_operacion,
            max_op_red: data.max_op_red,
            max_op_30: data.max_op_30,
            tipo_vehiculo: data.tipo_vehiculo,
          });
        }
      } else {
        dispatch(startLogout('expired'));
      }
    } catch (error) {
      console.error(error);
      toast(t('flotas.table.editar-desactivada'), {
        icon: <LogoPetroprix />,
      });
    }
  };

  const selectAllVehicles = (e) => {
    if (e.target.checked) {
      setAllVehicles(true);
      const vehicles = document.querySelectorAll('div.vehiculo');
      vehicles.forEach((vehiculo) => {
        const checkbox = vehiculo.querySelector('input[type=checkbox]');
        checkbox.checked = true;
      });
    } else {
      setAllVehicles(false);
      const vehicles = document.querySelectorAll('div.vehiculo');
      vehicles.forEach((vehiculo) => {
        const checkbox = vehiculo.querySelector('input[type=checkbox]');
        checkbox.checked = false;
      });
    }
  };

  const isAnyVehicleSelected = (value) => {
    if (value) {
      onSelectVehicle(true);
    } else {
      let selectedVehicles = 0;
      const vehicles = document.querySelectorAll('div.vehiculo');
      vehicles.forEach((vehiculo) => {
        const checkbox = vehiculo.querySelector('input[type=checkbox]');
        if (checkbox.checked) {
          selectedVehicles++;
        }
      });
      if (selectedVehicles > 0) {
        onSelectVehicle(true);
      } else {
        onSelectVehicle(false);
      }
    }
  };

  return (
    <>
      <Table hover={false} className='flotas' borderless={true}>
        <thead>
          <tr>
            <th
              style={{ width: '1%' }}
              className='flotas-download-title step10'
              id='vehiculos-download-title'
            >
              <span>
                <Form.Check
                  type='checkbox'
                  className='flotas-table-select'
                  onClick={(e) => {
                    selectAllVehicles(e);
                    isAnyVehicleSelected(e.target.checked);
                  }}
                />
              </span>
            </th>
            <th className='flotas-table-header' style={{ width: '10%' }}>
              {t('flotas.table.matricula')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 0)} />
                <AiFillCaretUp onClick={orderData(true, 0)} />
              </span>
            </th>
            <th className='flotas-table-header' style={{ width: '10%' }}>
              {t('flotas.table.vehiculo')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 1)} />
                <AiFillCaretUp onClick={orderData(true, 1)} />
              </span>
            </th>
            <th className='flotas-table-header' style={{ width: '12%' }}>
              {t('flotas.table.combustible')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 2)} />
                <AiFillCaretUp onClick={orderData(true, 2)} />
              </span>
            </th>
            <th className='flotas-table-header' style={{ width: '11%' }}>
              {t('flotas.table.cred-definido')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 3)} />
                <AiFillCaretUp onClick={orderData(true, 3)} />
              </span>
            </th>
            <th className='flotas-table-header' style={{ width: '12%' }}>
              {t('flotas.table.cred-consumido')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 4)} />
                <AiFillCaretUp onClick={orderData(true, 4)} />
              </span>
            </th>
            <th className='flotas-table-header' style={{ width: '12%' }}>
              {t('flotas.table.estado')}{' '}
              <span className='order-table-icons float-end'>
                <AiFillCaretDown onClick={orderData(false, 5)} />
                <AiFillCaretUp onClick={orderData(true, 5)} />
              </span>
            </th>
            {estadoFlota === '1' ? (
              <th style={{ width: '8%' }} className='flotas-table-header'>
                {t('flotas.table.acciones')}
              </th>
            ) : (
              <></>
            )}
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((vehiculo) => (
            <tr
              key={vehiculo.id_vehiculo_flota}
              id={'vehiculo-' + vehiculo.id_vehiculo_flota}
            >
              <td className='repostajes-download'>
                <Form.Check
                  type='checkbox'
                  className='flotas-table-select vehiculo'
                  key={vehiculo.id_vehiculo_flota}
                  value={vehiculo.id_vehiculo_flota}
                  defaultChecked={allVehicles}
                  onClick={(e) => {
                    isAnyVehicleSelected(e.target.checked);
                  }}
                />
              </td>
              <td className='flotas-matricula'>
                {normalizarMatricula(vehiculo.matricula)}
              </td>
              <td className='flotas-vehiculo'>
                {vehiculo.tipo_vehiculo === '0'
                  ? t('flotas.modal.editar.form.tipo-vehiculo.turismo')
                  : vehiculo.tipo_vehiculo === '1'
                  ? t('flotas.modal.editar.form.tipo-vehiculo.moto')
                  : t('flotas.modal.editar.form.tipo-vehiculo.camion')}
              </td>
              <td className='flotas-combustible'>
                {vehiculo.tipo === 'Gasolina' ? (
                  <Alert variant='success'>Gasolina</Alert>
                ) : vehiculo.tipo === 'Diesel' ? (
                  <Alert variant='warning'>Diésel</Alert>
                ) : (
                  <Alert variant='default'>-</Alert>
                )}
              </td>
              <td className='flotas-credito'>
                {vehiculo.credito_definido === -1
                  ? 'Sin límite'
                  : `${vehiculo.credito_definido} zł`}
              </td>
              <td className='flotas-credito'>{vehiculo.credito_usado} zł</td>
              <td
                className='flotas-estado'
                id={'estado-' + vehiculo.id_vehiculo_flota}
              >
                {switchEstado(vehiculo.estado)}
              </td>
              {estadoFlota == '1' ? (
                <td
                  className='flotas-btn'
                  id={'btns-' + vehiculo.id_vehiculo_flota}
                >
                  {vehiculo.estado == '1' ? (
                    <>
                      <Button variant='light' className='user-config table-btn'>
                        <img
                          src={edit_icon}
                          alt='Editar vehículo'
                          className='edit-icon-btn'
                          onClick={() =>
                            fetchTarjetaData(vehiculo.id_vehiculo_flota)
                          }
                        />
                      </Button>
                      <Button variant='light' className='user-config table-btn'>
                        <img
                          src={delete_icon}
                          alt='Borrar vehículo'
                          className='delete-icon-btn'
                          onClick={() =>
                            setModalBorrar({
                              show: true,
                              vehiculo: vehiculo,
                            })
                          }
                        />
                      </Button>
                    </>
                  ) : vehiculo.estado == '2' ? (
                    <Button
                      variant='light'
                      className='user-config table-btn btn-icon-font'
                    >
                      <FontAwesomeIcon
                        icon={faLock}
                        className='table-btn block-icon-btn'
                        onClick={() =>
                          setModalInfoBloqueado({
                            show: true,
                            vehiculo: vehiculo,
                          })
                        }
                      />
                    </Button>
                  ) : (
                    vehiculo.estado == '0' && (
                      <Button variant='light' className='user-config table-btn'>
                        <img
                          src={reactivate_icon}
                          alt='Reactivar vehículo'
                          className='reactivate-icon-btn'
                          onClick={() =>
                            setModalReactivar({
                              show: true,
                              vehiculo: vehiculo,
                            })
                          }
                        />
                      </Button>
                    )
                  )}
                </td>
              ) : (
                <></>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        recordsPerPage={recordsPerPage}
        totalRecords={vehiculos.length}
        setRecordsPerPage={setRecordsPerPage}
      />

      <ModalEditarVehiculo
        show={modalEditar.show}
        onHide={(edited = false) => {
          if (edited) {
            // fetchVehicleData();
            updateRow(modalEditar.id_tar, 'reactivate');
          }
          setModalEditar({ ...modalEditar, show: false });
        }}
        id_cuenta_facturacion={modalEditar.id_cuenta_facturacion}
        id_vehiculo_flota={modalEditar.id_vehiculo_flota}
        matricula={modalEditar.matricula}
        descripcion={modalEditar.descripcion}
        credito_definido={modalEditar.credito_definido}
        credito_usado={modalEditar.credito_usado}
        factura={modalEditar.factura}
        max_operacion={modalEditar.max_operacion}
        max_op_red={modalEditar.max_op_red}
        max_op_30={modalEditar.max_op_30}
        tipo_vehiculo={modalEditar.tipo_vehiculo}
      />

      <ModalBorrarVehiculo
        show={modalBorrar.show}
        onHide={(deleted = false, personales = false) => {
          if (deleted && personales) {
            updateRow(modalBorrar.vehiculo.id_vehiculo_flota, 'delete');
          } else if (deleted && !personales) {
            updateRow(modalBorrar.vehiculo.id_vehiculo_flota, 'desactivate');
          }
          setModalBorrar({ ...modalBorrar, show: false });
        }}
        vehiculo={modalBorrar.vehiculo}
      />

      <ModalReactivarVehiculo
        show={modalReactivar.show}
        onHide={(create = false, reactivated = false) => {
          setModalReactivar({ show: false });
          if (create) {
            setModalNuevo({
              show: true,
              vehiculo: modalReactivar.vehiculo,
              validated: false,
            });
          }
          if (reactivated) {
            updateRow(modalReactivar.vehiculo.id_vehiculo_flota, 'reactivate');
          }
        }}
        vehiculo={modalReactivar.vehiculo}
      />

      <ModalNuevoVehiculo
        show={modalNuevo.show}
        onHide={(create = false, data = null) => {
          setModalNuevo({ ...modalNuevo, show: false });
          if (create) {
            updateRow(modalNuevo.vehiculo.id_vehiculo_flota, 'create', data);
          }
        }}
        vehiculo={modalNuevo.vehiculo}
      />

      <ModalInfoBloqueado
        show={modalInfoBloqueado.show}
        onHide={(unlocked = false) => {
          setModalInfoBloqueado({ ...modalInfoBloqueado, show: false });
          if (unlocked) {
            updateRow(modalInfoBloqueado.vehiculo.id_vehiculo_flota, 'unlock');
          }
        }}
        vehiculo={modalInfoBloqueado.vehiculo}
      />
    </>
  );
};
